import { useQuery } from '@tanstack/react-query';

import {
  ApprovalSide,
  ApproverList,
  getApprovers,
} from '@/services/workflow/qualification';

export const APPROVERS_QUERY_KEY = 'qualification-approvers';

export const useApprovers = (
  client: string | undefined,
  region: string | undefined,
  side: ApprovalSide,
  waveId?: string,
) =>
  useQuery<ApproverList, Error>({
    queryKey: [APPROVERS_QUERY_KEY, client, region, side, waveId ?? null],
    queryFn: ({ signal }) => {
      if (!client || !region) throw new Error('No client or region');
      return getApprovers(client, region, side, waveId, signal);
    },
    enabled: !!client && !!region,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
